import React from "react";
import { Link } from "react-router-dom";

export const SectionLabel = ({ n, children, testId }) => (
  <div className="section-label" data-testid={testId}>
    {n ? <span className="n">{n}</span> : null}
    <span>{children}</span>
  </div>
);

export const Section = ({ id, n, label, title, children, below, visual, pale = false, split = false, testId }) => {
  const head = (
    <div className="section-head">
      <SectionLabel n={n} testId={`${testId}-label`}>{label}</SectionLabel>
      {title ? <h2 className="h-section" data-testid={`${testId}-title`}>{title}</h2> : null}
      {visual ? <div className="section-visual">{visual}</div> : null}
    </div>
  );
  return (
    <section id={id} className={`section${pale ? " section--pale" : ""}`} data-testid={testId}>
      <div className="container-syni">
        {split ? (
          <div className="section-split">
            {head}
            <div>{children}</div>
          </div>
        ) : (
          <>
            {head}
            {children}
          </>
        )}
        {below ? <div className="section-below">{below}</div> : null}
      </div>
    </section>
  );
};

export const Arrow = () => (
  <span className="arr" aria-hidden="true">
    →
  </span>
);

export const Band = ({ label, title, body, links = [], children, testId }) => (
  <section className="band" data-testid={testId}>
    <div className="container-syni band-inner">
      <div>
        <SectionLabel>{label}</SectionLabel>
        {title ? <h2 className="band-title">{title}</h2> : null}
      </div>
      <div>
        {body ? <p className="band-body">{body}</p> : null}
        {children}
        {links.length ? (
          <div className="band-links">
            {links.map((l) => (
              <Link key={l.to} to={l.to} className="link-peach" data-testid={l.testId}>
                <Arrow /> {l.label}
              </Link>
            ))}
          </div>
        ) : null}
      </div>
    </div>
  </section>
);

export const Hero = ({ label, title, lead, children, page = true, testId }) => (
  <section className={`hero${page ? " hero--page" : ""}`} data-testid={testId}>
    <div className="container-syni">
      {label ? <SectionLabel>{label}</SectionLabel> : null}
      <h1 className={`${page ? "h-page" : "h-display"} hero-headline`} data-testid={`${testId}-title`}>
        {title}
      </h1>
      {lead ? (
        <p className="lead hero-sub" data-testid={`${testId}-lead`}>
          {lead}
        </p>
      ) : null}
      {children}
    </div>
  </section>
);
